module.exports = __webpack_public_path__ + "static/media/cal-blank.6f462fde.svg";